import store from "./vuex/store"
import {getToken, getJWT,} from '@/common/oauth'
// 导入路由
import router, {resetRouter} from '@/base/router'
// 导入进度条实例
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({showSpinner: false})


const whiteList = ['/login', '/operator/join']

function toLogin(next) {
  next({path: '/login'})
}

// 拦截路由，检查登陆
router.beforeEach(async (to, from, next) => {
  // 加载进度条
  NProgress.start()

  const token = getToken()

  // 非白名单路由，且cookie中不存在token，则跳转去登录
  if (!token) {
    // 白名单中的路由，直接跳转
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      toLogin(next)
    }
    return
  }

  try {
    // 存在token，则去获取用户信息
    const userType = store.getters.userType
    if (userType) {
      next()
    } else {
      // 没获取到信息，则通过jwt里的username去后台获取用户信息
      let userClaim = getJWT()

      if (!userClaim) {
        // 去后台获取jwt信息
        const {data} = await store.dispatch('user/getUserJWT')
        // 获取成功，重新赋值
        userClaim = data.jwt_token
      }

      // 获取用户信息（用户名不能从store中拿，会出现异常）
      const username = JSON.parse(Base64.decode(userClaim.split('.')[1])).user_name

      const {permissions, userType} = await store.dispatch('user/getUserInfo', username)
      console.log('userType:' + userType)

      //先重置路由，避免路由重复加入
      resetRouter()
      // 动态加载路由
      const accessRoutes = await store.dispatch('permission/generateRoutes', permissions)
      router.addRoutes(accessRoutes)

      next({...to, replace: true})
    }

  } catch (error) {
    // remove token and go to login page to re-login
    await store.dispatch('user/resetToken')
    console.log(error)
    toLogin(next)
    NProgress.done()
  }
})

router.afterEach(transition => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js